import { useTranslation } from 'react-i18next';
import { CompactTable, Flex, Switch } from '@mss/mss-component-library';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Tooltip } from 'antd';
import StatusIcon from '../../../common/StatusIcon';
import { useHistory } from 'react-router-dom';

const AutomationCompactTable = ({ resources, loading }: any) => {
  const [t] = useTranslation(['common']);
  const automationsRoute = '/configuration/automations/{ID}';
  const history = useHistory();
  const showLogs = (event: React.SyntheticEvent, automationId: string) => {
    event.stopPropagation();
    history.push(`/configuration/automations/${automationId}/log`);
  };

  return (
    <CompactTable
      bordered={false}
      dataSource={resources}
      onRow={(record: any) => ({
        onClick: () => {
          history.push(automationsRoute.replace('{ID}', record.id));
        },
      })}
      loading={loading}
      columns={[
        {
          title: t('Name'),
          dataIndex: 'name',
          key: 'name',
          defaultSortOrder: 'ascend',
          sorter: (a: any, b: any) =>
            a.name?.toUpperCase() > b.name?.toUpperCase() ? 1 : -1,
        },
        {
          title: t('Debug'),
          dataIndex: 'debug',
          key: 'debug',
          width: 50,
          render: (debug: boolean) => (
            <Flex h="center" v="center">
              <Switch size="small" isChecked={debug} disabled />
            </Flex>
          ),
        },
        {
          title: t('Status'),
          dataIndex: 'enabled',
          key: 'enabled',
          width: 50,
          render: (enabled: boolean) => (
            <Flex h="center" v="center">
              <Switch size="small" isChecked={enabled} disabled />
            </Flex>
          ),
        },
        {
          title: t('Log'),
          width: 50,
          render: (automation: any) =>
            !isEmpty(automation.error) ? (
              <Tooltip title={automation.error.message}>
                <Flex
                  h="center"
                  v="center"
                  onClick={event => showLogs(event, automation.id)}
                >
                  <StatusIcon
                    enabled={automation.enabled && isEmpty(automation.error)}
                    error={automation.enabled && !isEmpty(automation.error)}
                  />
                </Flex>
              </Tooltip>
            ) : (
              <Flex
                h="center"
                v="center"
                onClick={event => showLogs(event, automation.id)}
              >
                <StatusIcon
                  enabled={automation.enabled && isEmpty(automation.error)}
                  error={automation.enabled && !isEmpty(automation.error)}
                />
              </Flex>
            ),
        },
      ]}
      rowKey={'id'}
    />
  );
};

export default AutomationCompactTable;
